import React, { useState, useEffect } from 'react';

const Mapillary = ({ imageKey }) => {
  const [havePicture, setHavePicture] = useState();
  const [containerId] = React.useState(`mapillary_${imageKey}_${Math.random().toString()}`);

  useEffect(() => {
    let mounted = true;

    const loadMapillary = async () => {
      const mly = new window.mapillary.Viewer({
        accessToken: 'MLY|4605841792830146|f176fb83c0ac1d6b7610034ed5118d54',
        container: containerId,
      });

      try {
        await mly.moveTo(imageKey);
        mounted && setHavePicture(true);
      } catch (e) {
        console.error(e);
        mounted && setHavePicture(false);
      }

      return mly;
    };

    loadMapillary();

    return () => {
      mounted = false;
    };
  }, [containerId, imageKey]);

  return (
    <div id={containerId} style={{ height: 400, backgroundColor: 'black' }}>
      {!havePicture && (
        <div style={{ textAlign: 'center', padding: '2em', color: 'white' }}>
          Aucune image <a href="https://www.mapillary.com/capture">Mapillary</a> disponible
          à proximité.
        </div>
      )}
    </div>
  );
};

export default Mapillary;
